import Vue from 'vue'
import { axios } from '@/utils/request'

const api = {
  user: '/api/user',
  role: '/api/role',
  service: '/api/service',
  permission: '/api/permission',
  permissionNoPager: '/api/permission/no-pager'
}

export default api

//post
export function postAction(url,parameter) {
  return axios({
    url: url,
    method:'post' ,
    data: parameter
  })
}

export function handleOkSubmit(url,parameter) {
  return axios({
    url: url,
    method:'post' ,
    data: parameter
  })
}


//post method= {post | put}
export function httpAction(url,parameter,method) {
  return axios({
    url: url,
    method:method ,
    data: parameter
  })
}

//put
export function putAction(url,parameter) {
  return axios({
    url: url,
    method:'post',
    data: parameter
  })
}

//get
export function getAction(url,parameter) {
  return axios({
    url: url,
    method: 'get',
    params: parameter
  })
}

//deleteAction
export function deleteAction(url,parameter) {
  return axios({
    url: url,
    method: 'delete',
    params: parameter
  })
}

export function getUserList(parameter) {
  return axios({
    url: api.user,
    method: 'get',
    params: parameter
  })
}

export function getRoleList(parameter) {
  return axios({
    url: api.role,
    method: 'get',
    params: parameter
  })
}

export function getServiceList(parameter) {
  return axios({
    url: api.service,
    method: 'get',
    params: parameter
  })
}

export function getPermissions(parameter) {
  return axios({
    url: api.permissionNoPager,
    method: 'get',
    params: parameter
  })
}

// id == 0 add     post
// id != 0 update  put
export function saveService(parameter) {
  return axios({
    url: api.service,
    method: parameter.id == 0 ? 'post' : 'put',
    data: parameter
  })
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url,parameter){
  return axios({
    url: url,
    params: parameter,
    method:'get' ,
    responseType: 'blob'
  })
}

/**
 * 下载文件
 * @param url 文件路径
 * @param fileName 文件名
 * @param parameter
 * @returns {*}
 */
export function downloadFile(url, fileName, parameter) {
  return downFile(url, parameter).then((data) => {
    if (!data || data.size === 0) {
      Vue.prototype['$message'].warning('文件下载失败')
      return
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data]), fileName)
    } else {
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(url) //释放掉blob对象
    }
  })
}

/**
 * 文件上传 用于富文本上传图片
 * @param url
 * @param parameter
 * @returns {*}
 */
export function uploadAction(url,parameter){
  return axios({
    url: url,
    data: parameter,
    method:'post' ,
    headers: {
      'Content-Type': 'multipart/form-data',  // 文件上传
    },
  })
}

/**
 * 获取带token的文件访问路径
 * @param filePath 文件路径
 * @returns {Promise}
 */
export function getSecureFileUrl(filePath) {
  return axios({
    url: '/oss/file/queryFullPath',
    method: 'get',
    params: { filePath: filePath }
  })
}

/**
 * 获取文件服务访问路径（带防盗链支持）
 * @param avatar
 * @param subStr
 * @returns {Promise|String}
 */
export function getFileAccessHttpUrl(avatar, subStr) {
  if (!subStr) subStr = 'http'
  
  // 如果已经是完整的HTTP URL，直接返回
  if (avatar && avatar.startsWith(subStr)) {
    return Promise.resolve(avatar);
  } else {
    if (avatar && avatar.length > 0 && avatar.indexOf('[') == -1) {
      // 对于FastDFS文件，使用防盗链接口获取带token的URL
      return getSecureFileUrl(avatar).then(res => {
        if (res.success && res.result) {
          return res.result;
        } else {
          // 如果获取失败，回退到原来的方式
          return window._CONFIG['staticDomainURL'] + "/" + avatar;
        }
      }).catch(() => {
        // 如果接口调用失败，回退到原来的方式
        return window._CONFIG['staticDomainURL'] + "/" + avatar;
      });
    }
  }
  return Promise.resolve(avatar);
}

/**
 * 获取文件服务访问路径（同步版本，用于兼容旧代码）
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export function getFileAccessHttpUrlSync(avatar, subStr) {
  if (!subStr) subStr = 'http'
  if (avatar && avatar.startsWith(subStr)) {
    return avatar;
  } else {
    if (avatar && avatar.length > 0 && avatar.indexOf('[') == -1) {
      return window._CONFIG['staticDomainURL'] + "/" + avatar;
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/api/manage.js